export function validate(formData = {}) {
  const errors = {};

  const { child } = formData;

  if(!child.lastName) errors.childLastName = 'Не зазначена інформація щодо прізвища дитини.';

  return errors;
}